import { createUseStyles } from 'react-jss';

var styles = {
  section: {
    position: 'relative',
    '&:not(:last-child)': { marginBottom: '1.5rem' }
  },
  sectionTitle: {
    fontSize: '1.6rem',
    fontWeight: '700',
    marginBottom: '1.5rem',
    marginTop: 0
  }
};

var createStyles = createUseStyles(styles);
export { createStyles };
//# sourceMappingURL=styles.js.map